function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_782_35483)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.53951 24.1406L4.18477 24.9227V23.3584H2.42695V24.9227L1.07227 24.1406L0.193359 25.6629L1.54805 26.4451L0.193359 27.2272L1.07227 28.7495L2.42695 27.9673V29.5316H4.18477V27.9673L5.53951 28.7495L6.41842 27.2272L5.06367 26.4451L6.41842 25.6629L5.53951 24.1406Z",
  fill: "current"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.3647 24.1406L13.01 24.9227V23.3584H11.2521V24.9227L9.89746 24.1406L9.01855 25.6629L10.3732 26.4451L9.01855 27.2272L9.89746 28.7495L11.2521 27.9673V29.5316H13.01V27.9673L14.3647 28.7495L15.2436 27.2272L13.8889 26.4451L15.2436 25.6629L14.3647 24.1406Z",
  fill: "current"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.1899 24.1406L21.8352 24.9227V23.3584H20.0773V24.9227L18.7227 24.1406L17.8438 25.6629L19.1985 26.4451L17.8438 27.2272L18.7227 28.7495L20.0773 27.9673V29.5316H21.8352V27.9673L23.1899 28.7495L24.0688 27.2272L22.7141 26.4451L24.0688 25.6629L23.1899 24.1406Z",
  fill: "current"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.3408 2.66602L21.8144 0.460358L23.5336 0.829511L23.06 3.03517L21.3408 2.66602Z",
  fill: "current"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.9404 2.4043L16.417 1.4498L17.6416 3.34423L16.165 4.29873L14.9404 2.4043Z",
  fill: "current"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.4219 12.0723L27.791 10.3531L29.9967 10.8267L29.6275 12.5459L27.4219 12.0723Z",
  fill: "current"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.166 5.1748L28.0604 3.95019L29.0149 5.42675L27.1205 6.65137L26.166 5.1748Z",
  fill: "current"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.9277 12.3102C22.5188 12.3102 22.1227 12.3646 21.7459 12.4654C21.1641 10.8436 19.6137 9.68398 17.7926 9.68398C17.7598 9.68398 17.7275 9.68574 17.6953 9.68633C17.1973 6.96582 14.8166 4.90332 11.952 4.90332C8.72695 4.90332 6.11191 7.51777 6.11191 10.7434C6.11191 10.7615 6.11309 10.7797 6.11367 10.7984C5.86348 10.7627 5.60859 10.7434 5.34844 10.7434C2.39473 10.7434 0 13.1375 0 16.0918C0 19.0455 2.39473 21.4402 5.34844 21.4402H22.9277C25.449 21.4402 27.4928 19.3965 27.4928 16.8752C27.4928 14.3539 25.449 12.3102 22.9277 12.3102Z",
  fill: "current"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.0625 8.06174C19.8485 8.23207 20.5924 8.56131 21.2576 9.03768C21.8429 9.4568 22.3409 9.97002 22.7352 10.5557C23.8374 10.5142 25.1269 10.8203 26.099 11.4028C26.2589 10.8814 26.3452 10.3279 26.3452 9.7541C26.3452 6.65332 23.8315 4.13965 20.7308 4.13965C19.4293 4.13965 18.2314 4.58262 17.2793 5.32576C18.0537 6.0866 18.669 7.01479 19.0625 8.06174Z",
  fill: "current"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_782_35483"
}, /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 30,
  fill: "white"
})));

function SvgWeather(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeather);
export default __webpack_public_path__ + "static/media/weather.20370495.svg";
export { ForwardRef as ReactComponent };